import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import { TIMEOUT_STORE, TIMESTAMP_MULTIPLY } from 'util/constants';

module.exports = {
    createFetchParams: (startDate, filters) => {
        return {
            bucket_id: filters.bucket_id,
            date: Math.floor(startDate / TIMESTAMP_MULTIPLY)
        }
    },
    ...storeModuleFactory({
        name: 'objectStorageOccupancy',
        endpoint: endpoints.storage.storageObjectOccupancy,
        timeout: TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => {
            if (response.results) {
                return {
                    assignedTb: response.results.assigned_tb,
                    freeTb: response.results.free_tb,
                    usedTb: response.results.used_tb
                };
            }

            return [];
        }
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/objectStorageOccupancy.js